/* eslint-disable react-hooks/exhaustive-deps */
import BuypassAddressSelector, { AddressModel, BuypassAdressValidationSchema } from "Components/Common/BuypassAddressSelector";
import ErrorModal from "Components/Common/ErrorModal";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond/dist/filepond.min.css";
import { useFormik } from "formik";
import { updateAddress } from "live-slices/business/thunk";
import { updateUserState } from "live-slices/user/reducer";
import { isBoolean } from "lodash";
import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Col,
  Form,
  Row
} from "reactstrap";
import { createSelector } from "reselect";
import { getAuthMe } from "slices/thunks";
import { getOptionToSetTouched } from "utils/helperfunctions";
import * as Yup from "yup";

// Register the plugins


interface ChildFormProps {
  setFormikAddressRef: (instance: { handleSubmit: () => Promise<boolean> }) => void;
}


const AddressTwo: React.FC<ChildFormProps> = ({ setFormikAddressRef }) => {
  document.title = "Shop Address | BuyPass";
  const dispatch: any = useDispatch();
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const selectuserProfile = createSelector(
    (state: any) => state.Business,
    (business) => business?.business
  );
  const selectUser = createSelector(
    (state: any) => state.User,
    (user) => user?.user,
  );

  const user = useSelector(selectUser)
  const seller = useSelector(selectuserProfile);

  useEffect(() => {
    if (seller.address) {
      const updatedValues = {
        ...formik.values,
        address: {
          ...formik.values.address,
          ...AddressModel.copyFromObject(seller.address),
        },
      };
      formik.setValues(updatedValues, false);
    }
  }, [seller]);



  const validationSchema = Yup.object({
    address: Yup.object(BuypassAdressValidationSchema),
  });

  // Initialize Formik
  const formik = useFormik({
    initialValues: {
      address: new AddressModel(),
    },
    validationSchema,
    onSubmit: (values, { setTouched }) => {

    },
  });

  useEffect(() => {
    console.log(formik.values);
  }, [formik]);

  React.useEffect(() => {
    setFormikAddressRef({
      handleSubmit: async () => {
        let isValue = false
        const errors = await formik.validateForm();
        if (Object.keys(errors).length === 0) {
          formik.handleSubmit();

          let objectToSetTouched = getOptionToSetTouched(formik.values);
          // setTouched(objectToSetTouched);
          if (formik.isValid) {
            const updatedSeller = {
              ...seller,
              address: AddressModel.copyFromObject(formik.values.address),

              isReturnAddressSame: true,
            };
            try {
              let result = await dispatch(updateAddress({ formData: updatedSeller, navigate }))
              if (result && result.error && result.error.message) {
                // toast.error("Address Updated Failed")
                setShowModal(true);
                setErrorMessage("Address Updated Failed")
                setTimeout(() => {
                  setShowModal(false);
                }, 2000);
                isValue = false;
              }
              else {
                // await dispatch(getAuthMe);
                await dispatch(
                  updateUserState({
                    storeStatus: {
                      ...user.storeStatus,
                      isAddressAdded: true,
                    },
                  })
                );
                //  toast.success("Address Updated Successfully")
                setShowModal(true);
                setErrorMessage("Address Updated Successfully")
                setTimeout(() => {
                  setShowModal(false);
                }, 2000);
                isValue = true;

              }
            } catch (e) {
              isValue = false
              // toast.error("Address Updated Failed")
              setShowModal(true);
              setErrorMessage("Address Updated Failed")
              setTimeout(() => {
                setShowModal(false);
              }, 2000);
            }
            return isValue;

          }

          // toast.success("Address Added Successfully", { autoClose: 2000 });
          setShowModal(true);
          setErrorMessage("Address Added Successfully")
          setTimeout(() => {
            setShowModal(false);
          }, 2000);
        } else {
          let objectToSetTouched = getOptionToSetTouched(formik.values);
          formik.setTouched(objectToSetTouched);
          console.log('Form errors:', errors);
          isValue = false; // Indicate form is invalid
        }

        return isValue;
      }
    });
  }, [formik, setFormikAddressRef]);


  return (
    <>
      <ErrorModal
        show={showModal}
        message={errorMessage}
        onCloseClick={() => setShowModal(false)}
      />
      <Row >
        <Form onSubmit={formik.handleSubmit} className="d-flex justify-content-center">
          <Col sm={12} lg={12} md={12} >
            <div className="mt-2 mb-2 d-flex  flex-column">
              <h2 className="shop-title">Where Will You Ship From?</h2>
              <h5 className="card-title mb-0 shop-details-description">Add your pickup location so we can coordinate <br />deliveries smoothly</h5>
            </div>
            <BuypassAddressSelector formik={formik} />
          </Col>
        </Form>
      </Row>
    </>

  );
};

export default AddressTwo;
